
interface ProductBottleProps {
  productName: string;
  specification: string;
  purity: string;
  batchNumber?: string;
  className?: string;
}

export default function ProductBottle({
  productName,
  specification,
  purity,
  batchNumber = 'DB-2025-001',
  className = '',
}: ProductBottleProps) {
  return (
    <div className={`relative flex items-center justify-center ${className}`}>
      {/* Bottle Container */}
      <div className="relative w-32 h-44">
        {/* Bottle Cap */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-4 bg-gradient-to-b from-teal-500 to-teal-600 rounded-t-sm shadow-md z-10">
          <div className="absolute inset-x-1 top-0.5 h-1 bg-teal-400/50 rounded-full"></div>
        </div>
        
        {/* Bottle Neck */}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-8 h-4 bg-gradient-to-b from-gray-100 to-gray-200 rounded-sm"></div>
        
        {/* Bottle Body */}
        <div className="absolute top-6 left-1/2 -translate-x-1/2 w-28 h-36 bg-gradient-to-br from-white via-gray-50 to-gray-100 rounded-lg shadow-lg border border-gray-200 overflow-hidden">
          {/* Glass Reflection */}
          <div className="absolute top-0 left-0 w-full h-full">
            <div className="absolute top-0 left-2 w-1 h-full bg-gradient-to-b from-white/80 via-white/40 to-transparent"></div>
            <div className="absolute top-0 right-4 w-0.5 h-full bg-gradient-to-b from-white/60 via-white/20 to-transparent"></div>
          </div>
          
          {/* Label */}
          <div className="absolute inset-x-2 top-4 bottom-4 bg-white rounded-md shadow-sm border border-gray-100 overflow-hidden">
            {/* Label Header - DNBio Branding */}
            <div className="bg-gradient-to-r from-navy-900 to-navy-800 px-2 py-2">
              <div className="flex items-center justify-center space-x-1">
                <img
                  src="https://public.readdy.ai/ai/img_res/41008464-2da7-44e8-a4ad-cffce2d1a65f.png"
                  alt="DNBio"
                  className="h-3 w-auto"
                />
                <span className="text-white text-[8px] font-bold tracking-wider">DNBio</span>
              </div>
            </div>
            
            {/* Product Name */}
            <div className="px-1.5 py-2 text-center border-b border-gray-100">
              <h3 className="text-[9px] font-bold text-navy-900 leading-tight truncate">
                {productName}
              </h3>
              <p className="text-[7px] text-gray-600 mt-0.5">{specification}</p>
            </div>
            
            {/* Purity Badge */}
            <div className="px-1.5 py-2 text-center">
              <div className="inline-block px-2 py-0.5 bg-teal-50 rounded-full">
                <span className="text-[7px] font-semibold text-teal-700">{purity} Pure</span>
              </div>
            </div>
            
            {/* Batch Info */}
            <div className="px-1.5 py-2 text-center border-t border-gray-100">
              <p className="text-[6px] text-gray-500">Batch: {batchNumber}</p>
            </div>
          </div>
        </div>
        
        {/* Bottle Shadow */}
        <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-24 h-3 bg-gray-900/10 rounded-full blur-sm"></div>
      </div>
    </div>
  );
}
